<template>
  <!-- 专业教学标准管理 -->
  <div class="page">
    <loading v-if="showLoading" />
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="专业名称：">
            <el-input
              size="small"
              v-model="searchData.name"
              placeholder="请输入专业名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="add">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="tableObj.list" :height="tableHeight">
          <el-table-column prop="index" label="序号" align="center" width="60"> </el-table-column>
          <el-table-column prop="code" label="专业代码" align="center" width="120">
          </el-table-column>
          <el-table-column prop="title" label="专业名称" align="center"> </el-table-column>
          <el-table-column prop="jobfaceProfession" label="就业面向" align="center">
          </el-table-column>
          <el-table-column prop="secondaryJoin" label="衔接中职" align="center"> </el-table-column>
          <el-table-column prop="undergraduateCourseJoin" label="衔接本科" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
              <i class="icona icon-delete" title="删除" @click="cutOut(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :pageSize="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      width="800px"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form ref="uploadBox" :model="uploadBox.data" :rules="uploadBox.rules" label-width="160px">
        <el-form-item
          v-for="(item, index) in formItemGroup"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
          <el-input
            size="small"
            v-model="uploadBox.data[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      showLoading: false,
      // 查询条件
      searchData: {
        name: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      optId: "", //判断当前是修改还是新增操作  1-新增；2-修改
      // 新增弹窗
      uploadBox: {
        show: false,
        title: "",
        data: {
          id: null,
          code: "", //专业代码
          title: "", //专业名称
          jobGroup: "", //职业类别、岗位群
          trainGoal: "", //培养目标
          trainTypeQuality: "", //培养规格、素质
          trainTypeKnowledge: "", //培养规格、知识
          trainTypeAbility: "", //培养规格、能力
          courseSettingPublic: "", //课程设置、公共基础课
          courseSettingProfessional: "", //课程设置、专业课程
          qualityEnsure: "", //质量保证
          jobfaceProfession: "", //就业面向
          secondaryJoin: "", //衔接中职
          undergraduateCourseJoin: "", //衔接本科
          courseSchedules: "", //课程设置及学时安排
        },
        rules: {
          name: [{ required: true, message: "请输入专业名称", trigger: "blur" }],
        },
      },
      formItemGroup: [
        {
          option: "input",
          prop: "code",
          label: "专业代码",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "title",
          label: "专业名称",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "jobGroup",
          label: "职业类别、岗位群",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "trainGoal",
          label: "培养目标",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "trainTypeQuality",
          label: "培养规格、素质",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "trainTypeKnowledge",
          label: "培养规格、知识",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "trainTypeAbility",
          label: "培养规格、能力",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "courseSettingPublic",
          label: "课程设置、公共基础课",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "courseSettingProfessional",
          label: "课程设置、专业课程",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "qualityEnsure",
          label: "质量保证",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "jobfaceProfession",
          label: "就业面向",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "secondaryJoin",
          label: "衔接中职",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "undergraduateCourseJoin",
          label: "衔接本科",
          placeholder: "请输入",
        },
        {
          option: "input",
          prop: "courseSchedules",
          label: "课程设置及学时安排",
          placeholder: "请输入",
        },
      ],
      tableHeight: 0,//表格高度
    };
  },
  watch: {
    "specialtyBox.data.filterText"(val) {
      console.log(val);
      this.$refs.specialtyTree.filter(val);
    },
  },
  mounted() {
    // 初始化
    this.uploadBox.show = false;
    this.$store.commit("modifyVague", false);
    this.$nextTick(() => {
      this.renderTableHeight();
      window.onresize = () => this.renderTableHeight();
    this.search();
    });
  },
  methods: {
    // 动态渲染表格的高度
    renderTableHeight() {
      this.tableHeight = document.getElementsByClassName("table_box")[0].offsetHeight - 40;
    },
    // 查询表格
    search(page) {
      this.showLoading = true;
      this.searchData.pageDto.pageNum = page ? page : 1;
      this.tableObj.jumpTo = page ? page : 1;
      this.$axios
        .post(this.$apiurls.getProfessionStandardInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.list.length; i++) {
              if (this.searchData.pageDto.pageNum == 1) {
                res.data.list[i].index = i + 1;
              } else {
                res.data.list[i].index = i + 1 + (this.searchData.pageDto.pageNum - 1) * 10;
              }
            }
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
          this.showLoading = false;
        });
    },
    // 重置表格
    reset() {
      this.searchData.name = "";
      this.search();
    },
    // 点击编辑按钮
    edit(row) {
      this.optId = "2";
      this.uploadBox.title = "修改专业";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
      for (const key in this.uploadBox.data) {
        this.uploadBox.data[key] = row[key];
      }
    },
    // 点击删除按钮
    cutOut(id) {
      this.$store.commit("modifyVague", true);
      this.$confirm("此操作将永久删除该专业, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(
              this.$apiurls.delProfessionStandardInfo,
              { id },
              {
                loading: false,
              }
            )
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.uploadBox.show = false;
          this.$store.commit("modifyVague", false);
        });
    },
    // 点击新增按钮
    add() {
      // 每次新增打开弹框前都先清除之前的表单数据
      for (const key in this.uploadBox.data) {
        if (key === "id") this.uploadBox.data[key] = null;
        else this.uploadBox.data[key] = "";
      }
      this.optId = "1";
      this.uploadBox.title = "添加专业";
      this.uploadBox.show = true;
      this.$store.commit("modifyVague", true);
    },
    // 关闭弹框
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
      this.optId = "";
    },
    // 添加/修改专业请求接口
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          console.log(this.uploadBox.data);
          let url =
            this.optId === "1"
              ? this.$apiurls.addProfessionStandardInfo
              : this.optId === "2"
              ? this.$apiurls.editProfessionStandardInfo
              : "";
          if (!url) return;
          this.$axios
            .post(url, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.optId === "2" ? "编辑成功！" : "添加成功！",
                  type: "success",
                });
                this.search();
              }
              this.uploadBox.show = false;
              this.$store.commit("modifyVague", false);
              this.optId = "";
            });
        }
      });
    },
    // 弹框打开
    opened() {
      // 每次打开弹框都清空校验
      this.$refs.uploadBox.clearValidate();
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
.el-form {
  height: 100%;
}

// 分配专业
.distribute ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}
.distributionBox {
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: 10px;
}
.specialty_box {
  height: 470px;
  overflow-y: auto;
  // background: #a5a4bf;
  margin-bottom: 60px;
  margin-right: 20px;
}
.specialty_bottom {
  position: absolute;
  bottom: -45px;
  right: 38%;
}
.el-tree,
::v-deep.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content,
::v-deep.el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  height: calc(100% - 60px);
  margin-top: 14px;
}
</style>
